module.exports = __webpack_public_path__ + "img/Weapon_176.42a361ae.png";